import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    footerlinkList: null,
    selectedFooterTitle: null,
};

export const footerlinkSlice = createSlice({
    name: "footerlink",
    initialState,
    reducers: {
        updateFooterLink: (state, action) => {
            state.footerlinkList = action.payload;
        },
        clearFooterLink: (state) => {
            state.footerlinkList = null;
        },
        updateSelectedFooterTitle: (state, action) => {
            state.selectedFooterTitle = action.payload;
        },
        clearSelectedFooterTitle: (state) => {
            state.selectedFooterTitle = null;
        },    
    },
});

export const { updateFooterLink, clearFooterLink, updateSelectedFooterTitle, clearSelectedFooterTitle } = footerlinkSlice.actions;

export default footerlinkSlice.reducer;